// extracted by mini-css-extract-plugin
export var addToCartButton = "_p1-b";
export var arrowButtonContainer = "_p1-9";
export var arrowButtonIcon = "_p1-a";
export var carouselArrowButton = "_p1-6";
export var carouselElementContainer = "_p1-1";
export var galleryThumbnail = "_p1-d";
export var galleryThumbnailImage = "_p1-e";
export var left = "_p1-7";
export var productDisplayCarouselContainer = "_p1-0";
export var productTileContainer = "_p1-2";
export var productTileImage = "_p1-4";
export var productTileImageContainer = "_p1-3";
export var productTileTitle = "_p1-5";
export var right = "_p1-8";
export var sliderOverflow = "_p1-c";